// src/plugins/vuetify.js

// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles"; // Global styles for Vuetify

// Vuetify
import { createVuetify } from "vuetify";

// Create a Vuetify instance with a dark theme
export default createVuetify({
  theme: {
    dark: true, // Enable dark theme
    themes: {
      dark: {
        primary: "#bb86fc", // Customize your primary color
        secondary: "#03dac6", // Customize your secondary color
        accent: "#ff4081",
        error: "#cf6679",
        info: "#2196f3",
        success: "#4caf50",
        warning: "#fb8c00",
      },
    },
  },
});
